import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useRef } from "react";

import s1 from '../../img/s1.png';
import s2 from '../../img/s2.png';
import s3 from '../../img/s3.png';
import s4 from '../../img/s4.png';
import s5 from '../../img/s5.png';
import s6 from '../../img/s6.png';
import t1 from '../../img/t1.png';
import t2 from '../../img/t2.png';
import t3 from '../../img/t3.png';
import t4 from '../../img/t4.png';
import t5 from '../../img/t5.png';
import t6 from '../../img/t6.png';
import t7 from '../../img/t7.png';
import t8 from '../../img/t8.png';
import t9 from '../../img/t9.png';
import t10 from '../../img/t10.png';
import t11 from '../../img/t11.png';
import t12 from '../../img/t12.png';
import t13 from '../../img/t13.png';
import t14 from '../../img/t14.png';

const data = [
  { img: s1, title: 'home.57', stage: 'home.58', text: 'home.59' },
  { img: s2, title: 'home.60', stage: 'home.61', text: 'home.62' },
  { img: s3, title: 'home.63', stage: 'home.64', text: 'home.65' },
  { img: s4, title: 'home.66', stage: 'home.67', text: 'home.68' },
  { img: s5, title: 'home.69', stage: 'home.70', text: 'home.71' },
  { img: s6, title: 'home.72', stage: 'home.73', text: 'home.74' },
  { img: t1, title: 'home.75', stage: 'home.76', text: 'home.77' },
  { img: t2, title: 'home.78', stage: 'home.79', text: 'home.80' },
  { img: t3, title: 'home.81', stage: 'home.82', text: 'home.83' },
  { img: t4, title: 'home.84', stage: 'home.85', text: 'home.86' },
  { img: t5, title: 'home.87', stage: 'home.88', text: 'home.89' },
  { img: t6, title: 'home.90', stage: 'home.91', text: 'home.92' },
  { img: t7, title: 'home.93', stage: 'home.94', text: 'home.95' },
  { img: t8, title: 'home.96', stage: 'home.97', text: 'home.98' },
  { img: t9, title: 'home.99', stage: 'home.100', text: 'home.101' },
  { img: t10, title: 'home.102', stage: 'home.103', text: 'home.104' },
  { img: t11, title: 'home.105', stage: 'home.106', text: 'home.107' },
  { img: t12, title: 'home.108', stage: 'home.109', text: 'home.110' },
  { img: t14, title: 'home.114', stage: 'home.115', text: 'home.116' },
];

function MeatOurTeam() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);

  return (
    <>
      <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
        <div className="flex justify-between items-center">
          <p className="host-grotesk leading-[1.2] xl:text-[40px] text-[#2A323F] text-[28px]">{t('home.56')}</p>
          <div className="flex items-center gap-[20px]">
            <svg className="cursor-pointer hover:scale-[0.95] transition-all" onClick={() => swiperRef.current?.slidePrev()} xmlns="http://www.w3.org/2000/svg" width="41" height="15" viewBox="0 0 41 15" fill="none">
              <path d="M0.292893 6.65666C-0.0976295 7.04718 -0.0976296 7.68035 0.292892 8.07087L6.65685 14.4348C7.04738 14.8254 7.68054 14.8254 8.07107 14.4348C8.46159 14.0443 8.46159 13.4111 8.07107 13.0206L2.41422 7.36377L8.07107 1.70691C8.46159 1.31639 8.46159 0.683223 8.07107 0.292699C7.68054 -0.0978256 7.04738 -0.0978256 6.65685 0.292699L0.292893 6.65666ZM41 7.36377L41 6.36377L1 6.36377L1 7.36377L1 8.36377L41 8.36377L41 7.36377Z" fill="#2A323F" />
            </svg>
            <svg className="cursor-pointer hover:scale-[0.95] transition-all" onClick={() => swiperRef.current?.slideNext()} xmlns="http://www.w3.org/2000/svg" width="41" height="15" viewBox="0 0 41 15" fill="none">
              <path d="M40.7071 8.07088C41.0976 7.68035 41.0976 7.04719 40.7071 6.65666L34.3431 0.292702C33.9526 -0.0978227 33.3195 -0.0978227 32.9289 0.292702C32.5384 0.683226 32.5384 1.31639 32.9289 1.70692L38.5858 7.36377L32.9289 13.0206C32.5384 13.4111 32.5384 14.0443 32.9289 14.4348C33.3195 14.8254 33.9526 14.8254 34.3431 14.4348L40.7071 8.07088ZM0 7.36377V8.36377H40V7.36377V6.36377H0V7.36377Z" fill="#2A323F" />
            </svg>
          </div>
        </div>
        <div className="mt-[30px] xl:mt-[40px]">
          <Swiper
            modules={[Autoplay]}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            spaceBetween={20}
            breakpoints={{
              320: { slidesPerView: 1 },
              450: { slidesPerView: 2 },
              768: { slidesPerView: 4 },
              1280: { slidesPerView: 4 },
            }}
            loop
          >
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="bg-[#F0F0F0] h-[350px] md:h-[380px] relative">
                  <img src={item.img} className="w-full h-[270px] object-cover object-top" alt={t(item.title)} />
                  <h3 className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px] px-[20px] pt-[20px]">{t(item.title)}</h3>
                  <p className="px-[20px] text-[#000000B2] mt-[6px] PtRoot font-[700] text-[12px] xl:text-[14px]">{t(item.stage)}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
}

export default MeatOurTeam;
